import styled from 'styled-components'

export const StyledLayout = styled.div``

export const CoreContent = styled.div`
  min-height: ${({ addHeaderPadding, headerHeight }) =>
    addHeaderPadding ? `calc(100vh - ${headerHeight})` : '100vh'};
  ${({ addHeaderPadding }) => addHeaderPadding && `padding-top: 60px`}
`
